.transparent {
    background-color: transparent;
}

.white {
    composes: light from "../../styles/theming.module.css";
}

.black {
    composes: dark from "../../styles/theming.module.css";
}
